import { faFigma, faGithub, faGooglePlay, faLinkedin, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const SocialWrapper = styled.div`
  position: fixed;
  left: 20px;
  top: 70%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  &::before {
    content: '';
    width: 1px;
    height: calc(100% + 20px);
    background-color: #828282;
    position: absolute;
    top: 16rem;
    left: 50%;
    transform: translateX(-50%);
  }

  a {
    color: #828282;
    font-size: 1.5rem;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #f5c32c;
    }
  }

  @media (max-width: 992px) {
    display: none;
  }
`;

const SocialMediaLinks = () => (
  <SocialWrapper>
    <a href="https://github.com/konti-aditi" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faGithub} />
    </a>
    <a href="https://www.linkedin.com/in/aditirshinde/" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faLinkedin} />
    </a>
    <a href="https://www.youtube.com/@konti_aditi" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faYoutube} />
    </a>
    <a href="https://www.figma.com/@aditi48" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faFigma} />
    </a>
    <a href="https://play.google.com/store/apps/" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faGooglePlay} />
    </a>
    <a href="https://x.com/konti_aditi" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faTwitter} />
    </a>
    
  </SocialWrapper>
);

export default SocialMediaLinks;
